import moment from "moment";
import { isBusinessCard } from "../../components/businessCardBadge";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface TableItens {
  text: string;
  bold?: boolean;
  fillColor?: string;
  margin: number[];
  border: boolean[];
  fontSize: number;
}

const OrderPDF = (
  orderDescription: number,
  order: any,
  itens: any,
  advances: any,
  spendingTypes: any,
  totalValue: number,
  totalAdvances: number
) => {
  console.log(itens);

  let arrayItens: Array<TableItens[]> = [
    [
      {
        text: "Nº",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, false, false],
        fontSize: 10,
      },
      {
        text: "Categoria",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, false, false],
        fontSize: 10,
      },
      {
        text: "Status",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, false, false],
        fontSize: 10,
      },
      {
        text: "Data",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, false, false],
        fontSize: 10,
      },
      {
        text: "Valor",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, false, false],
        fontSize: 10,
      },
      {
        text: "Cidade",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
      {
        text: "Modelo",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
      {
        text: "Placa",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
      {
        text: "Qtd",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
      {
        text: "Vlr/L",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
      {
        text: "Km",
        bold: true,
        fillColor: "#c5c5c5",
        margin: [3, 2, 0, 2],
        border: [true, true, true, false],
        fontSize: 10,
      },
    ],
  ];

  itens.map((i: any) => {
    arrayItens.push([
      {
        text: i.id,
        margin: [1, 2, 0, 1],
        border: [true, false, false, true],
        fontSize: 8,
      },
      {
        text: i.type,
        margin: [1, 2, 0, 1],
        border: [true, false, false, true],
        fontSize: 8,
      },
      {
        text: i.status,
        margin: [1, 2, 0, 1],
        border: [true, false, false, true],
        fontSize: 8,
      },
      {
        text: moment(i.date).format("DD/MM/YYYY"),
        margin: [1, 2, 0, 1],
        border: [true, false, false, true],
        fontSize: 8,
      },
      {
        text: parseFloat(i.value).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        }),
        margin: [1, 2, 0, 1],
        border: [true, false, false, true],
        fontSize: 8,
      },
      {
        text: i.city + " - " + i.uf,
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
      {
        text: i.vehicle_model,
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
      {
        text: i.license_plate,
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
      {
        text: i.amount ? parseFloat(i.amount).toLocaleString("pt-br") : "",
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
      {
        text:
          i.amount && i.value
            ? (parseFloat(i.value) / parseFloat(i.amount)).toLocaleString(
                "pt-br",
                { style: "currency", currency: "BRL" }
              )
            : "",
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
      {
        text: i.mileage ?? "",
        margin: [1, 2, 0, 1],
        border: [true, false, true, true],
        fontSize: 8,
      },
    ]);
  });

  var dd = {
    content: [
      {
        table: {
          widths: [200, "*"],
          body: [
            [
              {
                image:
                  "data:image/png;base64,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",
                width: 180,
                border: [false, false, false, false],
              },
              {
                text: `RDI - Registro de Despesas Individuais - Nº ${orderDescription}`,
                alignment: "center",
                border: [false, false, false, false],
                margin: [0, 5, 0, 0],
                fontSize: 20,
                bold: true,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        text: "",
      },
      {
        table: {
          widths: ["*"],
          body: [
            [
              {
                text: "",
                border: [false, true, false, false],
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        text: "",
      },
      {
        text: "Informações da Ordem",
        bold: true,
        fontSize: 16,
        border: [true, true, true, false],
        margin: [0, 0, 0, 15],
        fillColor: "#c5c5c5",
      },
      {
        alignment: "center",
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Data de Cadastro",
                bold: true,
                border: [true, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Status",
                bold: true,
                border: [false, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
            ],
            [
              {
                text: moment(order.created_at).format("DD/MM/YYYY"),
                margin: [2, 2, 2, 2],
                border: [true, false, true, false],
              },
              {
                text: order.status,
                margin: [2, 2, 2, 2],
                border: [false, false, true, false],
              },
            ],
            [
              {
                text: "Usuário",
                bold: true,
                border: [true, false, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Centro de Custo",
                bold: true,
                border: [true, false, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
            ],
            [
              {
                text: order.name,
                margin: [2, 2, 2, 2],
                border: [true, false, true, false],
              },
              {
                text: order.cost_center,
                margin: [2, 2, 2, 2],
                border: [true, false, true, false],
              },
            ],
            [
              {
                text: "Cód. Centro de Custo",
                bold: true,
                border: [true, false, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Filial",
                bold: true,
                border: [true, false, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
            ],
            [
              {
                text: order.code,
                margin: [2, 2, 2, 2],
                border: [true, false, true, false],
              },
              {
                text: order.branch,
                margin: [2, 2, 2, 2],
                border: [true, false, true, false],
              },
            ],
            [
              {
                text: "Cartão Corporativo",
                bold: true,
                colSpan: 2,
                border: [true, false, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {},
            ],
            [
              {
                text: isBusinessCard(order.payment_business_card) ? "Sim" : "Não",
                colSpan: 2,
                margin: [2, 2, 2, 2],
                border: [true, false, true, true],
              },
              {},
            ],
          ],
        },
      },
      {
        text: "Informações do Usuário",
        bold: true,
        fontSize: 16,
        border: [true, true, true, false],
        margin: [0, 15, 0, 15],
        fillColor: "#c5c5c5",
      },
      {
        alignment: "center",
        table: {
          widths: ["*", "auto", "*", "*"],
          body: [
            [
              {
                text: "CPF",
                bold: true,
                border: [true, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Banco",
                bold: true,
                border: [true, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Agência",
                bold: true,
                border: [true, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
              {
                text: "Conta",
                bold: true,
                border: [true, true, true, false],
                margin: [2, 2, 2, 2],
                fillColor: "#c5c5c5",
              },
            ],
            [
              {
                text: order.cpf,
                border: [true, false, true, true],
                margin: [2, 2, 2, 2],
              },
              {
                text: order.bank,
                border: [true, false, true, true],
                margin: [2, 2, 2, 2],
              },
              {
                text: order.agency,
                border: [true, false, true, true],
                margin: [2, 2, 2, 2],
              },
              {
                text: order.account,
                border: [true, false, true, true],
                margin: [2, 2, 2, 2],
              },
            ],
          ],
        },
      },
      {
        text: "Informações dos Gastos",
        bold: true,
        fontSize: 16,
        border: [true, true, true, false],
        margin: [0, 15, 0, 15],
        fillColor: "#c5c5c5",
      },
      {
        alignment: "center",
        table: {
          widths: [135, "*", 135],
          body: [
            [
              {
                text: "Valor Total",
                fillColor: "#c5c5c5",
                margin: [2, 2, 2, 2],
                bold: true,
                border: [true, true, false, false],
              },
              {
                text: "Total de Adiantamentos",
                fillColor: "#c5c5c5",
                margin: [2, 2, 2, 2],
                bold: true,
                border: [true, true, false, false],
              },
              {
                text: "Total Restante",
                fillColor: "#c5c5c5",
                margin: [2, 2, 2, 2],
                bold: true,
                border: [true, true, true, false],
              },
            ],
            [
              {
                text: totalValue.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }),
                margin: [2, 2, 2, 2],
                border: [true, false, false, true],
              },
              {
                text: totalAdvances.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }),
                margin: [2, 2, 2, 2],
                border: [true, false, false, true],
              },
              {
                text: (totalValue - totalAdvances).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }),
                margin: [2, 2, 2, 2],
                border: [true, false, true, true],
              },
            ],
          ],
        },
      },
      {
        text: "Gastos por Categoria",
        bold: true,
        fontSize: 16,
        border: [true, true, true, false],
        margin: [0, 15, 0, 15],
        fillColor: "#c5c5c5",
      },
      {
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Categoria",
                fillColor: "#c5c5c5",
                margin: [5, 4, 50, 4],
                bold: true,
                border: [true, true, false, false],
              },
              {
                text: "Valor",
                fillColor: "#c5c5c5",
                margin: [5, 4, 5, 4],
                bold: true,
                border: [true, true, true, false],
              },
            ],
          ],
        },
      },
      {
        table: {
          widths: ["*", "*"],
          body: spendingTypes.map((s: any) => {
            return [
              {
                text: s.type,
                margin: [5, 4, 50, 4],
                border: [true, false, false, true],
              },
              {
                text: parseFloat(s.value).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }),
                margin: [5, 4, 5, 4],
                border: [true, false, true, true],
              },
            ];
          }),
        },
      },
      advances.length > 0
        ? [
            {
              text: "Adiantamentos",
              bold: true,
              fontSize: 16,
              border: [true, true, true, false],
              margin: [0, 15, 0, 15],
              fillColor: "#c5c5c5",
            },
            {
              table: {
                widths: [50, "*", 90, "*"],
                body: [
                  [
                    {
                      text: "ID",
                      fillColor: "#c5c5c5",
                      bold: true,
                      border: [true, true, false, false],
                      margin: [5, 2, 2, 2],
                    },
                    {
                      text: "Descrição",
                      fillColor: "#c5c5c5",
                      bold: true,
                      border: [true, true, false, false],
                      margin: [5, 2, 2, 2],
                    },
                    {
                      text: "Valor",
                      fillColor: "#c5c5c5",
                      bold: true,
                      border: [true, true, false, false],
                      margin: [5, 2, 2, 2],
                    },
                    {
                      text: "Responsável",
                      fillColor: "#c5c5c5",
                      bold: true,
                      border: [true, true, true, false],
                      margin: [5, 2, 2, 2],
                    },
                  ],
                ],
              },
            },
            {
              table: {
                widths: [50, "*", 90, "*"],
                body: advances.map((a: any) => {
                  return [
                    {
                      text: a.id,
                      border: [true, false, false, true],
                      margin: [5, 2, 5, 2],
                    },
                    {
                      text: a.description,
                      border: [true, false, false, true],
                      margin: [5, 2, 5, 2],
                    },
                    {
                      text: parseFloat(a.value).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      }),
                      border: [true, false, false, true],
                      margin: [5, 2, 5, 2],
                    },
                    {
                      text: a.name,
                      border: [true, false, true, true],
                      margin: [5, 2, 5, 2],
                    },
                  ];
                }),
              },
            },
          ]
        : {},
      {
        text: "Itens",
        bold: true,
        fontSize: 16,
        border: [true, true, true, false],
        margin: [0, 15, 0, 15],
        fillColor: "#c5c5c5",
      },
      {
        table: {
          widths: Array(arrayItens[0].length).fill("auto"),
          body: arrayItens.map((row) =>
            row.map((cell) => ({
              ...cell,
              fontSize: 6,
              margin: [2, 1],
              fillColor: "#f0f0f0",
              border: [true, true, true, true],
              padding: [4, 6],
            }))
          ),
        },
        layout: "lightHorizontalLines",
        pageBreak: "auto",
        fontSize: 6,
      },
    ],
  };

  pdfMake.createPdf(dd).open();
};

export default OrderPDF;
